import { request } from './client';

export const apiAdminCountries = () => request('/geo/admin/countries');
export const apiCreateCountry = (body) => request('/geo/admin/countries', { method: 'POST', body });
export const apiUpdateCountry = (code, body) => request(`/geo/admin/countries/${code}`, { method: 'PUT', body });
export const apiDeleteCountry = (code) => request(`/geo/admin/countries/${code}`, { method: 'DELETE' });
